var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"p-3"},_vm._l((_vm.data),function(item,index){return _c('where-list-item',{key:index,attrs:{"item":item,"name":_vm.name,"checked":item.name === _vm.value},on:{"input":_vm.changeValue}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }